import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06b3c1d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center uppercase" }
const _hoisted_2 = { class: "flex flex-row flex-wrap p-2" }
const _hoisted_3 = { class: "h-3rem surface-border border-0 justify-content-center w-full" }
const _hoisted_4 = { class: "text-center uppercase" }
const _hoisted_5 = {
  key: 2,
  class: "formgroup-inline w-full"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"formgroup-inline pl-2 w-full\" data-v-06b3c1d0><div class=\"text-xs font-light text-500 w-11rem\" data-v-06b3c1d0>(výška balkóna do 1.7m </div><div class=\"text-xs font-light text-500 ml-2 w-1rem\" data-v-06b3c1d0> 6 </div><div class=\"text-xs font-light text-500 ml-1\" data-v-06b3c1d0>mm) </div></div><div class=\"formgroup-inline pl-2 w-full\" data-v-06b3c1d0><div class=\"text-xs font-light text-500 w-11rem\" data-v-06b3c1d0>(výška balkóna od 1.7m do 2.2m </div><div class=\"text-xs font-light text-500 ml-2 w-1rem\" data-v-06b3c1d0> 8 </div><div class=\"text-xs font-light text-500 ml-1\" data-v-06b3c1d0>mm) </div></div><div class=\"formgroup-inline pl-2 w-full\" data-v-06b3c1d0><div class=\"text-xs font-light text-500 w-11rem\" data-v-06b3c1d0>(výška balkóna nad 2.2m </div><div class=\"text-xs font-light text-500 ml-2 w-1rem\" data-v-06b3c1d0>10 </div><div class=\"text-xs font-light text-500 ml-1\" data-v-06b3c1d0>mm) </div></div>", 3)
const _hoisted_9 = {
  key: 3,
  class: "formgroup-inline w-full"
}
const _hoisted_10 = {
  key: 9,
  class: "formgroup-inline pl-2 w-full"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-light text-500 w-11rem" }, "(profily s plastovými kolieskami ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-light text-500 ml-2 w-3rem" }, "170 ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-light text-500 ml-1" }, "mm) ", -1))
const _hoisted_14 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 10,
  class: "formgroup-inline pl-2 w-full"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-light text-500 w-11rem" }, "(profily s oceľovými kolieskami ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-light text-500 ml-2 w-3rem" }, "175, 177 ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-light text-500 ml-1" }, "mm) ", -1))
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 12,
  class: "formgroup-inline pl-2 w-full"
}
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"text-xs font-light text-500 w-5rem\" data-v-06b3c1d0>(čierne krytky </div><div class=\"text-xs font-light text-500 ml-0 w-1rem\" data-v-06b3c1d0>15 </div><div class=\"text-xs font-light text-500 ml-0\" data-v-06b3c1d0>mm, </div><div class=\"text-xs font-light text-500 w-5rem ml-2\" data-v-06b3c1d0>sivé krytky </div><div class=\"text-xs font-light text-500 ml-0 w-1rem\" data-v-06b3c1d0>16 </div><div class=\"text-xs font-light text-500 ml-0\" data-v-06b3c1d0>mm) </div>", 6)
const _hoisted_27 = [
  _hoisted_21
]
const _hoisted_28 = {
  key: 16,
  type: "hidden",
  name: "holes",
  id: "holes",
  value: "true"
}
const _hoisted_29 = {
  key: 0,
  style: {"color":"var(--red-500)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_row_input = _resolveComponent("row-input")!
  const _component_InputGroupAddon = _resolveComponent("InputGroupAddon")!
  const _component_InputGroup = _resolveComponent("InputGroup")!
  const _component_TextArea = _resolveComponent("TextArea")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["border-round-lg border-1", `${$props.typeWall === $data.position.FRONT ? 'border-pink-500' : $props.typeWall === $data.position.LEFT ? 'border-cyan-500' : 'border-indigo-500'}`])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["surface-border border-round-top-lg justify-content-center", `${$props.typeWall === $data.position.FRONT ? 'bg-pink-300' : $props.typeWall === $data.position.LEFT ? 'bg-cyan-300' : 'bg-indigo-300'}`])
    }, [
      _createElementVNode("h5", _hoisted_1, _toDisplayString($data.nameTypeWall), 1)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, [
          _createTextVNode("Otváranie "),
          _createVNode(_component_row_input, {
            name: "opening",
            id: "opening",
            labelFront: "Otváranie",
            labelBack: "",
            defaultValue: this.opening,
            type: "select-opening",
            option: this.store.opening_types,
            ref: "glassTemperedThickness",
            onNewWallValue: $options.ChangeInput
          }, null, 8, ["defaultValue", "option", "onNewWallValue"])
        ])
      ]),
      _createVNode(_component_InputGroup, { class: "h-2rem" }, {
        default: _withCtx(() => [
          _createVNode(_component_InputGroupAddon, { class: "w-7 uppercase font-medium text-xs text-700 surface-400" }, {
            default: _withCtx(() => [
              _createTextVNode("Názov")
            ]),
            _: 1
          }),
          _createVNode(_component_InputGroupAddon, { class: "w-3 uppercase font-medium text-xs text-700 surface-400" }, {
            default: _withCtx(() => [
              _createTextVNode("Zadaj")
            ]),
            _: 1
          }),
          _createVNode(_component_InputGroupAddon, { class: "w-2 uppercase font-medium text-xs text-700 surface-400" }, {
            default: _withCtx(() => [
              _createTextVNode("Jednotky")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_row_input, {
        name: "width",
        id: "width",
        required: "true",
        labelFront: "Šírka balkóna/Lodžie",
        labelBack: "[mm]",
        defaultValue: this.wall.width,
        type: "number",
        ref: "width",
        onNewWallValue: $options.ChangeInput
      }, null, 8, ["defaultValue", "onNewWallValue"]),
      _createVNode(_component_row_input, {
        name: "height",
        id: "height",
        required: "true",
        labelFront: "Výša balkóna/Lodžie",
        labelBack: "[mm]",
        defaultValue: this.wall.height,
        type: "number",
        ref: "height",
        validationAlert: !this.validationOK,
        onNewWallValue: $options.ChangeInput
      }, null, 8, ["defaultValue", "validationAlert", "onNewWallValue"]),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createBlock(_component_row_input, {
            key: 0,
            name: "framesCount",
            id: "framesCount",
            required: "true",
            labelFront: "Počet krídel skiel",
            labelBack: "[ks]",
            defaultValue: this.wall.framesCount,
            type: "number",
            ref: "framesCount",
            onNewWallValue: $options.ChangeInput
          }, null, 8, ["defaultValue", "onNewWallValue"]))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createBlock(_component_row_input, {
            key: 1,
            name: "openingDirection",
            id: "openingDirection",
            labelFront: "Otváranie skiel",
            labelBack: "[-]",
            defaultValue: this.wall.openingDirection,
            type: "select",
            option: this.store.opening_direction,
            ref: "openingDirection",
            onNewWallValue: $options.ChangeInput
          }, null, 8, ["defaultValue", "option", "onNewWallValue"]))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_row_input, {
              name: "glassTemperedThickness",
              id: "glassTemperedThickness",
              labelFront: "Hrúbka kalených skiel",
              labelBack: "[mm]",
              defaultValue: this.wall.glassTemperedThickness,
              type: "select",
              option: this.store.glass_tempered_thickness,
              ref: "glassTemperedThickness",
              onNewWallValue: $options.ChangeInput
            }, null, 8, ["defaultValue", "option", "onNewWallValue"]),
            _hoisted_6
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (this.store.order.id !== 0 && !this.wall.glassType)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_row_input, {
                    name: "glassConnexThickness",
                    id: "glassConnexThickness",
                    labelFront: "Hrúbka CONNEX skiel",
                    labelBack: "[mm]",
                    defaultValue: this.wall.glassConnexThickness,
                    type: "select",
                    option: this.store.connex_thickness,
                    ref: "glassConnexThickness",
                    onNewWallValue: $options.ChangeInput
                  }, null, 8, ["defaultValue", "option", "onNewWallValue"]),
                  _createVNode(_component_row_input, {
                    name: "glassConnexType",
                    id: "glassConnexType",
                    labelFront: "Typ skla",
                    labelBack: "[-]",
                    defaultValue: this.wall.glassConnexType,
                    type: "select",
                    option: this.store.fix_glass_types,
                    ref: "glassTemperedThickness",
                    onNewWallValue: $options.ChangeInput
                  }, null, 8, ["defaultValue", "option", "onNewWallValue"])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_row_input, {
                    name: "glassType",
                    id: "glassType",
                    labelFront: "Výber skla",
                    labelBack: "[-]",
                    defaultValue: this.wall.glassType,
                    type: "select",
                    option: this.store.glass_types,
                    ref: "glassType",
                    onNewWallValue: $options.ChangeInput
                  }, null, 8, ["defaultValue", "option", "onNewWallValue"]),
                  (this.wall.glassType == 'Connex')
                    ? (_openBlock(), _createBlock(_component_row_input, {
                        key: 0,
                        name: "glassConnexThickness",
                        id: "glassConnexThickness",
                        labelFront: "Typ skla",
                        labelBack: "[-]",
                        defaultValue: this.wall.glassConnexThickness,
                        type: "select",
                        option: this.store.connex_thickness,
                        ref: "glassConnexThickness",
                        onNewWallValue: $options.ChangeInput
                      }, null, 8, ["defaultValue", "option", "onNewWallValue"]))
                    : _createCommentVNode("", true),
                  (this.wall.glassType == 'Connex')
                    ? (_openBlock(), _createBlock(_component_row_input, {
                        key: 1,
                        name: "glassConnexCollorType",
                        id: "glassConnexCollorType",
                        labelFront: "Farba skla",
                        labelBack: "[-]",
                        defaultValue: this.wall.glassConnexType,
                        type: "select",
                        option: this.store.fix_connex_glass_types,
                        ref: "glassConnexCollorType",
                        onNewWallValue: $options.ChangeInput
                      }, null, 8, ["defaultValue", "option", "onNewWallValue"]))
                    : _createCommentVNode("", true),
                  (this.wall.glassType == 'Iný druh')
                    ? (_openBlock(), _createBlock(_component_row_input, {
                        key: 2,
                        name: "glassConnexType",
                        id: "glassConnexType",
                        labelFront: "Typ skla",
                        labelBack: "[-]",
                        defaultValue: this.wall.glassConnexType,
                        type: "select",
                        option: this.store.fix_glass_types,
                        ref: "glassTemperedThickness",
                        onNewWallValue: $options.ChangeInput
                      }, null, 8, ["defaultValue", "option", "onNewWallValue"]))
                    : _createCommentVNode("", true)
                ], 64))
          ])),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createBlock(_component_row_input, {
            key: 4,
            name: "caseType",
            id: "caseType",
            labelFront: "Výška púzdra",
            labelBack: "[mm]",
            defaultValue: this.wall.caseType,
            type: "select",
            option: this.store.case_types,
            ref: "caseType",
            onNewWallValue: $options.ChangeInput
          }, null, 8, ["defaultValue", "option", "onNewWallValue"]))
        : _createCommentVNode("", true),
      ((this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
            && this.wall.caseType == $options.Models.CaseType.NONE)
        ? (_openBlock(), _createBlock(_component_row_input, {
            key: 5,
            name: "caseThickness",
            id: "caseThickness",
            labelFront: "Odčítanie púzdra na sklo",
            labelBack: "[mm]",
            defaultValue: this.wall.caseThickness,
            type: "select",
            option: this.store.case_type_range_0,
            ref: "caseThickness",
            onNewWallValue: $options.ChangeInput
          }, null, 8, ["defaultValue", "option", "onNewWallValue"]))
        : _createCommentVNode("", true),
      ((this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
            && this.wall.caseType == $options.Models.CaseType.CASE60)
        ? (_openBlock(), _createBlock(_component_row_input, {
            key: 6,
            name: "caseThickness",
            id: "caseThickness",
            labelFront: "Odčítanie púzdra na sklo",
            labelBack: "[mm]",
            defaultValue: this.wall.caseThickness,
            type: "select",
            option: this.store.case_type_range_60,
            ref: "caseThickness",
            onNewWallValue: $options.ChangeInput
          }, null, 8, ["defaultValue", "option", "onNewWallValue"]))
        : _createCommentVNode("", true),
      ((this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
            && this.wall.caseType == $options.Models.CaseType.CASE90)
        ? (_openBlock(), _createBlock(_component_row_input, {
            key: 7,
            name: "caseThickness",
            id: "caseThickness",
            labelFront: "Odčítanie púzdra na sklo",
            labelBack: "[mm]",
            defaultValue: this.wall.caseThickness,
            type: "select",
            option: this.store.case_type_range_90,
            ref: "caseThickness",
            onNewWallValue: $options.ChangeInput
          }, null, 8, ["defaultValue", "option", "onNewWallValue"]))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createBlock(_component_row_input, {
            key: 8,
            name: "anotherProfilesThickness",
            id: "anotherProfilesThickness",
            labelFront: "Odčítanie iných profilov",
            labelBack: "[mm]",
            defaultValue: this.wall.anotherProfilesThickness,
            type: "number",
            ref: "anotherProfilesThickness",
            onNewWallValue: $options.ChangeInput
          }, null, 8, ["defaultValue", "onNewWallValue"]))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_14))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_19))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createBlock(_component_row_input, {
            key: 11,
            name: "capType",
            id: "capType",
            labelFront: "Typ krytiek",
            labelBack: "[mm]",
            defaultValue: this.wall.capType,
            type: "select",
            option: this.store.cap_type,
            ref: "capType",
            onNewWallValue: $options.ChangeInput
          }, null, 8, ["defaultValue", "option", "onNewWallValue"]))
        : _createCommentVNode("", true),
      (this.wall.opening != $options.Opening.FIXED)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_27))
        : _createCommentVNode("", true),
      _createVNode(_component_row_input, {
        name: "profilesColor",
        id: "profilesColor",
        labelFront: "Farba profilov",
        labelBack: "[-]",
        defaultValue: this.wall.profilesColor,
        type: "text-blank",
        ref: "profilesColor",
        onNewWallValue: $options.ChangeInput
      }, null, 8, ["defaultValue", "onNewWallValue"]),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createBlock(_component_row_input, {
            key: 13,
            name: "glazingType",
            name2: "glazingTypeAttribute",
            id: "glazingType",
            labelFront: "Stopsol",
            labelBack: "farba",
            defaultValue: this.wall.glazingType,
            defaultValue2: this.wall.glazingTypeAttribute,
            type: "select-select",
            option: this.store.glazing_type,
            option2: this.store.glazing_type_attribute,
            ref: "glazingType",
            onNewWallValue: $options.ChangeInput
          }, null, 8, ["defaultValue", "defaultValue2", "option", "option2", "onNewWallValue"]))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED)
        ? (_openBlock(), _createBlock(_component_row_input, {
            key: 14,
            name: "fixLeft",
            name2: "fixLeftWidth",
            id: "fixLeft",
            labelFront: "Fix vľavo",
            label: "Šírka fixu",
            labelBack: "[mm]",
            defaultValue: this.wall.fixLeft,
            defaultValue2: this.wall.fixLeftWidth,
            type: "checkbox-number",
            ref: "fixLeft",
            onNewWallValue: $options.ChangeInput
          }, null, 8, ["defaultValue", "defaultValue2", "onNewWallValue"]))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED)
        ? (_openBlock(), _createBlock(_component_row_input, {
            key: 15,
            name: "fixRight",
            name2: "fixRightWidth",
            id: "fixRight",
            labelFront: "Fix vpravo",
            label: "Šírka fixu",
            labelBack: "[mm]",
            defaultValue: this.wall.fixRight,
            defaultValue2: this.wall.fixRightWidth,
            type: "checkbox-number",
            ref: "fixRight",
            onNewWallValue: $options.ChangeInput
          }, null, 8, ["defaultValue", "defaultValue2", "onNewWallValue"]))
        : _createCommentVNode("", true),
      (this.typeCode == $options.TypeCode.B_F_H)
        ? (_openBlock(), _createElementBlock("input", _hoisted_28))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.FIXED)
        ? (_openBlock(), _createBlock(_component_row_input, {
            key: 17,
            name: "fixedVerticalSplits",
            id: "fixedVerticalSplits",
            required: "false",
            labelFront: "Počet vertikálnych členení",
            labelBack: "[ks]",
            defaultValue: this.wall.fixedVerticalSplits,
            type: "number",
            ref: "fixedVerticalSplits",
            onNewWallValue: $options.ChangeInput
          }, null, 8, ["defaultValue", "onNewWallValue"]))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.FIXED)
        ? (_openBlock(), _createBlock(_component_row_input, {
            key: 18,
            name: "fixedHorizontalSplits",
            id: "fixedHorizontalSplits",
            required: "false",
            labelFront: "Počet horizontálnych členení",
            labelBack: "[ks]",
            defaultValue: this.wall.fixedHorizontalSplits,
            type: "number",
            ref: "fixedHorizontalSplits",
            onNewWallValue: $options.ChangeInput
          }, null, 8, ["defaultValue", "onNewWallValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_InputGroup, { class: "h-2rem mt-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_InputGroupAddon, { class: "w-full uppercase font-medium text-sm text-800 bg-gray-300" }, {
            default: _withCtx(() => [
              _createTextVNode("Poznámky")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_InputGroup, null, {
        default: _withCtx(() => [
          _createVNode(_component_TextArea, {
            autoResize: "",
            rows: "2",
            class: "w-full",
            placeholder: "Poznámka ku stene",
            modelValue: this.wall.comment,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.wall.comment) = $event)),
            style: {"background":"#b8d6f0","text-align":"left"}
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_InputGroup, { class: "h-2rem mt-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_InputGroupAddon, { class: "w-full uppercase font-medium text-sm text-800 bg-red-300" }, {
            default: _withCtx(() => [
              _createTextVNode("Výstupné údaje")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createBlock(_component_InputGroup, {
            key: 19,
            class: "h-3rem"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Predbežný výpočet šírky všetkých profilov")
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(this.wall.profilesLength), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode("[mm]")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createBlock(_component_InputGroup, {
            key: 20,
            class: "h-2rem mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Šírka profilu")
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(this.wall.singleProfileLength), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode("[mm]")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED && this.wall.fixLeftWidth > 0)
        ? (_openBlock(), _createBlock(_component_InputGroup, {
            key: 21,
            class: "h-2rem mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Šírka profilu FIXU ľavý")
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(this.wall.fixLeftProfileWidth), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode("[mm]")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED && this.wall.fixRightWidth > 0)
        ? (_openBlock(), _createBlock(_component_InputGroup, {
            key: 22,
            class: "h-2rem mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Šírka profilu FIXU pravý")
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(this.wall.fixRightProfileWidth), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode("[mm]")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createBlock(_component_row_input, {
            key: 23,
            name: "manualSingleProfileLength",
            id: "manualSingleProfileLength",
            labelFront: "Zadaná šírka profilu",
            labelBack: "[mm]",
            defaultValue: this.wall.manualSingleProfileLength,
            type: "number",
            ref: "manualSingleProfileLength",
            backgroundText: "bg-gray-300",
            onNewWallValue: $options.ChangeInput
          }, null, 8, ["defaultValue", "onNewWallValue"]))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createBlock(_component_InputGroup, {
            key: 24,
            class: "h-2rem mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start bg-gray-300" }, {
                default: _withCtx(() => [
                  _createTextVNode(" Prepočtová šírka "),
                  (this.getTotalLengthDiff() > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, "  -" + _toDisplayString(this.getTotalLengthDiff()) + "mm! ", 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    style: _normalizeStyle(this.getTotalLengthDiff() > 0 ? 'color: var(--red-500)':'')
                  }, _toDisplayString(this.wall.totalProfilesLength), 5)
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode("[mm]")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createBlock(_component_InputGroup, {
            key: 25,
            class: "h-2rem"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-full uppercase font-medium text-sm text-800 bg-red-100" }, {
                default: _withCtx(() => [
                  _createTextVNode("Výpočet skutočnej šírky skla")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createBlock(_component_InputGroup, {
            key: 26,
            class: "h-2rem"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Krajné sklo")
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(this.wall.sideGlassWidth), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode("[mm]")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createBlock(_component_InputGroup, {
            key: 27,
            class: "h-2rem"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Počet krajných skiel")
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(this.wall.sideGlassCount), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode("[ks]")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createBlock(_component_InputGroup, {
            key: 28,
            class: "h-2rem mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Stredové sklo")
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(this.wall.middleGlassWidth), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode("[mm]")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createBlock(_component_InputGroup, {
            key: 29,
            class: "h-2rem"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Počet stredových skiel")
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(this.wall.middleGlassCount), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode("[ks]")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED || this.wall.opening == $options.Opening.SLIDING)
        ? (_openBlock(), _createBlock(_component_InputGroup, {
            key: 30,
            class: "h-2rem mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-7 font-medium text-base text-800 justify-content-start bg-red-100" }, {
                default: _withCtx(() => [
                  _createTextVNode("Výpočet výšky skiel")
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(this.wall.computedGlassHeight), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode("[mm]")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.COMBINED)
        ? (_openBlock(), _createBlock(_component_InputGroup, {
            key: 31,
            class: "h-2rem mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Šírka posuvu")
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(this.wall.centerRailingWidth), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode("[mm]")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.FIXED)
        ? (_openBlock(), _createBlock(_component_InputGroup, {
            key: 32,
            class: "h-2rem mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Šírka skla")
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(this.wall.fixedGlassWidth), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode("[mm]")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (this.wall.opening == $options.Opening.FIXED)
        ? (_openBlock(), _createBlock(_component_InputGroup, {
            key: 33,
            class: "h-2rem mt-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_InputGroupAddon, { class: "w-7 font-normal text-base text-700 justify-content-start" }, {
                default: _withCtx(() => [
                  _createTextVNode("Výška skla")
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-3 font-normal text-base text-700" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(this.wall.fixedGlassHeight), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_InputGroupAddon, { class: "w-2 font-normal text-sm" }, {
                default: _withCtx(() => [
                  _createTextVNode("[mm]")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 2))
}